/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import DynamicImage from '@salesforce/retail-react-app/app/components/dynamic-image'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPDPath} from '../../../utils/custom-utils'
import useSegment from '../../../integrations/segment/app/hooks/use-segment'

/**
 * Shop By series component
 *
 * @param {object} props
 * @param {string} - props.ITCLink - Image Link.
 * @param {string} - props.title - Text Below Image.
 * @param {image} - props.image - Image.
 * @param {string} - props.altText - The image alt text shown by the component.
 * @returns {React.ReactElement} - ImageWithText component.
 */
export const ShopBySeries = ({imageAltTag, tileUrl, target, custom}) => {
    const {site, locale} = useMultiSite()
    const categoryUrl = getPDPath(tileUrl, site, locale)
    const imageURL = custom?.image?.disBaseLink || ''
    const segment = useSegment()

    return (
        <Box
            className={'image-with-text-figure'}
            onClick={(event) => {
                // segment
                segment.sendPanelSelectedEvent(event, {})
            }}
        >
            <Link to={categoryUrl} aria-label={imageAltTag} display="block" target={target}>
                <DynamicImage
                    src={imageURL}
                    imageProps={{
                        alt: imageAltTag,
                        loading: 'lazy',
                        style: {
                            borderRadius: '8px',
                            marginBottom: '4px'
                        }
                    }}
                />
            </Link>
        </Box>
    )
}

ShopBySeries.propTypes = {
    imageAltTag: PropTypes.string,
    tileUrl: PropTypes.string,
    target: PropTypes.string,
    custom: PropTypes.object
}

export default ShopBySeries
